import { CompanyModel } from "../types";

const mapPageModelToRequest = (data: CompanyModel): string => {
  const {
    industryNogaCode = "",
    industryBranchCode = "",
    industrySubBranchCode = "",
  } = data;

  // If the company is manually entered the industryBranchCode needs to be addressed
  // Given a fake branch code means we have sub branch code that should be used.
  if (data.isCompanyManuallyEntered) {
    if (industryBranchCode.startsWith("fake")) {
      return industrySubBranchCode;
    }

    // We have branch code but no sub branches.
    return industryBranchCode;
  } else {
    if (data.industryNogaCode) {
      return industryNogaCode;
    }

    return "";
  }
};

const IndustrySectorMapper = {
  mapPageModelToRequest,
};

export default IndustrySectorMapper;
